<template>
  <tr
    style="cursor: pointer"
    @contextmenu="
      $emit('action', item.latest_done_schematisation_stage),
        setCurrentOverviewItem(item),
        $emit('show', $event)
    "
    @click="$emit('action', item.latest_done_schematisation_stage), setCurrentOverviewItem(item)"
    :class="{ 'selected-item': isSelected }"
  >
    <td class="left-column-border center-cell">
      <v-chip class="pl-2 pr-2" label size="x-small" :color="profile.properties.color">
        {{ profile ? profile.properties.name : 'Profile' }}
      </v-chip>
    </td>
    <td class="left-column-border">
      <span>{{ item.name }}</span>
    </td>
    <td class="left-column-border" style="min-width: 120px">
      <span style="font-size: 12px">{{ item.stages_done }} out of {{ item.length_stages }}</span>
    </td>
    <td class="left-column-border center-cell">
      <v-chip label size="x-small" :disabled="false">
        {{ year ? year.year : null }}
      </v-chip>
    </td>
    <td class="left-column-border center-cell">
      <RevisionChip :revision="item.stage_configuration_revision" size="x-small" icon="mdi-table" />
    </td>
    <td class="left-column-border center-cell">
      <RevisionChip :revision="item.soil_type_revision" size="x-small" icon="mdi-landslide" />
    </td>
    <td class="left-column-border center-cell">
      <RevisionChip
        :revision="item.water_line_rule_revision"
        size="x-small"
        icon="mdi-window-shutter-cog"
      />
    </td>
    <td
      style="min-width: 180px"
      :class="['left-column-border', textCenter(getNestValue(item, 'user'))]"
    >
      <span>{{ getValue(item, 'user_name') }}</span>
    </td>
    <td class="left-column-border center-cell" style="min-width: 180px"><span>---</span></td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.overtopping_rate') }}</span>
    </td>
    <td
      :class="[
        'left-column-border',
        textCenter(getNestValue(item, 'reinforcement_setting.starting_point'))
      ]"
    >
      <span>{{ getValue(item, 'reinforcement_setting.starting_point') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.x_location_connection') }}</span>
    </td>
    <td
      :class="['left-column-border', textCenter(getNestValue(baseSoilType, 'name'))]"
      style="min-width: 180px"
    >
      <span>{{ getValue(baseSoilType, 'name') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <v-chip v-if="continueSlope" label size="x-small" color="green"> True </v-chip>
      <v-chip v-if="continueSlope === false" label size="x-small" color="red"> False </v-chip>
      <span v-if="continueSlope === undefined">---</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.crest_level') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.width_crest') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.outer_slope') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.inner_slope') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{
        getValue(item, 'reinforcement_setting.height_crest_dike_to_berm_end_land_side')
      }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.width_berm_land_side') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.slope_berm_land_side') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{
        getValue(item, 'reinforcement_setting.height_crest_dike_to_berm_end_water_side')
      }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.width_berm_water_side') }}</span>
    </td>
    <td class="left-column-border center-cell">
      <span>{{ getValue(item, 'reinforcement_setting.slope_berm_water_side') }}</span>
    </td>
  </tr>
</template>
<script>
import RevisionChip from '@/components/revision/RevisionChip.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'OverviewTableRow',
  components: { RevisionChip },
  props: {
    item: {}
  },
  computed: {
    ...mapState('stabSchematisation', {
      items: (state) => state.items,
      currentOverviewItem: (state) => state.currentOverviewItem
    }),
    ...mapState('dikeProfiles', {
      dikeProfileItems: (state) => state.items,
      selectedStabSchematisationStageId: (state) => state.selectedStabSchematisationStageId
    }),
    ...mapState('dikeSection', {
      dikeSectionItems: (state) => state.items
    }),
    ...mapState('years', {
      currentYear: (state) => state.currentItem,
      years: (state) => state.items
    }),
    ...mapState('baseSoilType', {
      baseSoilTypeItems: (state) => state.items
    }),
    ...mapGetters('project', {
      selectedRevision: 'selectedRevision'
    }),
    profile() {
      return this.dikeProfileItems.features.find((item) => item.id === this.item.dike_profile)
    },
    baseSoilType() {
      return this.baseSoilTypeItems.find(
        (item) => item.id === this.item.reinforcement_setting?.base_soil_type
      )
    },
    continueSlope() {
      return this.item.reinforcement_setting?.continue_outer_slope
    },
    isSelected() {
      return this.item.id === this.currentOverviewItem?.id
    },
    section() {
      return this.dikeSectionItems.features.find(
        (item) => item.id === this.profile.properties.dikesection_id
      )
    },
    year() {
      return this.years.find((item) => item.id === this.item.year)
    }
  },
  methods: {
    ...mapActions('stabSchematisation', {
      setCurrentOverviewItem: 'setCurrentOverviewItem',
      toggleDeleteDialog: 'toggleDeleteDialog',
      toggleDialog: 'toggleDialog'
    }),
    getNestValue(item, parameter) {
      const arr = parameter.split('.')
      for (let i = 0; i < arr.length - 1; i++) {
        if (item) {
          if (item[arr[i]]) {
            item = item[arr[i]]
          } else {
            return null
          }
        }
      }
      return item ? item[arr[arr.length - 1]] : null
    },
    getValue(item, parameter) {
      const value = this.getNestValue(item, parameter)
      return value ? value : '---'
    },
    textCenter(item) {
      return item ? '' : 'center-cell'
    }
  }
}
</script>
<style scoped>
.left-column-border {
  border-left: solid 1px #f5f5f5;
}

.center-cell {
  text-align: center;
}
</style>
